module.exports = __webpack_public_path__ + "static/media/travel-prod-info-02.e55183b5.png";